import React from "react";

export const BehanceFilled = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 4C6.24 4 4 6.24 4 9V41C4 43.76 6.24 46 9 46H41C43.76 46 46 43.76 46 41V9C46 6.24 43.76 4 41 4H9ZM12 18H18.7305C19.4605 18 23.4102 17.9503 23.4102 21.5703C23.4102 23.4903 22.0998 24.1397 21.5098 24.4297C22.3898 24.7097 24 25.52 24 28C24 31.83 19.6095 32 19.0195 32H12V18ZM29 18H36V20H29V18ZM15 20.4297V23.7109H18.2207C18.6607 23.7109 20.1191 23.47 20.1191 22C20.1191 20.53 18.2197 20.4297 17.9297 20.4297H15ZM32.7305 21C36.6305 21 37.6896 24.0398 37.8496 24.7598C37.9996 25.4898 38 26.13 38 27H30.0996C30.0996 27.87 30.5606 29.8301 32.8906 29.8301C33.5106 29.8301 33.9695 29.6806 34.4395 29.3906C34.8995 29.1006 35.0609 28.8193 35.2109 28.5293H37.8398C37.3798 29.6793 36.7601 30.5509 35.8301 31.1309C34.9001 31.7109 33.8201 32 32.5801 32C31.8001 32 31.03 31.8505 30.25 31.5605C29.63 31.2705 29.0108 30.8402 28.5508 30.4102C28.0908 29.9702 27.7807 29.3899 27.4707 28.6699C27.1607 28.0899 27 27.22 27 26.5C27 25.78 27.2905 21 32.7305 21ZM32.7305 23.0293C30.4705 23.0293 30.0996 25.1998 30.0996 25.3398H35.0605C34.9005 24.6198 34.2505 23.0293 32.7305 23.0293ZM15 25.7109V29.5703H18.3516C18.6406 29.5703 20.6797 29.4809 20.6797 27.7109C20.6797 25.9509 19.0776 25.7109 18.3516 25.7109H15Z"
        fill="currentColor"
      />
    </svg>
  );
};
